import React from "react";
import { connect } from "react-redux"
import { withStyles } from '@material-ui/core/styles';
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import OTP from "./otp";

class OTPModel extends React.Component {
  constructor(props){
    super(props);
    this.state = {currentCount: 1800}
  }


  componentDidMount() {
    // this.intervalId = setInterval(this.timer.bind(this), 1000);
    this.timer = setInterval(() => {
      let {currentCount} =  this.state;
      this.setState({
        currentCount : currentCount -1
      })
    }, 1000)
  }
  componentDidUpdate(prevProps, prevState, snapshot){
     if(prevState.currentCount !== this.state.currentCount && this.state.currentCount === 0){
       clearInterval(this.timer)
     }
  }
  fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}

  render(){
    let {currentCount} = this.state;
    const { showModel, title, onCancel, onOk, eventTobeDeleted, handleGetEventList, getOtpVal } = this.props
    return(
      <Dialog open={showModel} onClose={onCancel}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
        <OTP eventTobeDeleted={eventTobeDeleted} handleGetEventList={handleGetEventList} getOtpVal={getOtpVal}/>
        </DialogContent>
        <div style={{display:'flex', justifyContent:'center'}}><h1>{this.fmtMSS(currentCount)} </h1></div>
        <DialogActions>
          <Button onClick={onCancel} color="primary" autoFocus>
            Close
          </Button>
          <Button onClick={onOk} color="primary" variant="contained" autoFocus>
            Submit OTP
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const OTPModelComponent = withStyles(extendedTablesStyle)(OTPModel);
export default connect(null)(OTPModelComponent);



// WEBPACK FOOTER //
// ./src/views/ISEAS/RefundMangement/index.js